.tablist {
    position: relative;
    display: flex;
    gap: var(--tempest-space-1);
    border-bottom: 1px solid var(--tempest-border);
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    /* Fade indicator on both edges when overflow horizontal. */
    mask-image: linear-gradient(
        to right,
        transparent 0,
        #000 var(--tempest-space-4),
        #000 calc(100% - var(--tempest-space-4)),
        transparent 100%
    );
    -webkit-mask-image: linear-gradient(
        to right,
        transparent 0,
        #000 var(--tempest-space-4),
        #000 calc(100% - var(--tempest-space-4)),
        transparent 100%
    );
}

.tablist::-webkit-scrollbar {
    display: none;
}

.tab {
    background: transparent;
    border: none;
    padding: var(--tempest-space-3) var(--tempest-space-4);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-base);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
    cursor: pointer;
    position: relative;
    white-space: nowrap;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .tab:hover:not(:disabled) {
        color: var(--tempest-text);
    }
}

.tab:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: -2px;
    border-radius: var(--tempest-radius-sm);
}

.tab.active {
    color: var(--tempest-primary);
}

.tab.active::after {
    content: "";
    position: absolute;
    left: var(--tempest-space-3);
    right: var(--tempest-space-3);
    bottom: -1px;
    height: 2px;
    background-color: var(--tempest-primary);
    border-radius: var(--tempest-radius-sm) var(--tempest-radius-sm) 0 0;
}

.tab:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.panel {
    padding: var(--tempest-space-4) 0;
}

.pill .tab {
    border-radius: var(--tempest-radius-full);
    padding: 6px var(--tempest-space-3);
    font-size: var(--tempest-text-sm);
}

.pill .tab.active::after {
    display: none;
}

.pill .tab.active {
    background-color: var(--tempest-primary);
    color: var(--tempest-primary-foreground);
}

.pill.tablist {
    border-bottom: none;
}
